import { render, staticRenderFns } from "./fireAlarmDetailDialog.vue?vue&type=template&id=ed820410&"
import script from "./fireAlarmDetailDialog.vue?vue&type=script&lang=js&"
export * from "./fireAlarmDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./fireAlarmDetailDialog.vue?vue&type=style&index=0&id=ed820410&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports